import type {AiVideoBackendData} from '@Libraries/ai-video.library';
import type {CanvasDropPosition} from '@Libraries/canvas-item-drag.library';

export const GENERATED_VIDEO_GRID_ID = 'generated-ai-video-grid';
export const GENERATED_VIDEO_GRID_ITEM_HEIGHT = 160;
export const AI_VIDEO_LOADING_SKELETON_ID_PREFIX = 'ai-video-loading-skeleton-';

export interface GeneratedVideoGridProps {
  isFullScreen: boolean;
  enableMultiSelection?: boolean;
  maxSelectionNumber?: number;
  enableDragToCanvas?: boolean;
  onAddToDesign: (backendData: AiVideoBackendData, dropPosition?: CanvasDropPosition) => void;
  onFullscreenPreview: (video: AiVideoBackendData) => void;
  onVideosLoaded: (videos: AiVideoBackendData[]) => void;
}
